import TypeSign from "./gen/qsign/types/TypeSign";

const labels = {
    [TypeSign.SIGN_COMBINATION]: "Volba podpisové konfigurace",
    [TypeSign.CUSTOM]: "Volba kombinace a podepisujících",
    [TypeSign.NO_SIGN]: "Bez podpisu",
};

export function getCaption(source: TypeSign) {
    const caption = labels[source];
    return caption ? caption : "[" + source + "]";
}

export function getValues() {
    return [TypeSign.CUSTOM, TypeSign.SIGN_COMBINATION, TypeSign.NO_SIGN];
}
